// Debug utility to check environment variables
const debugEnv = () => {
  console.log('Environment Variables:');
  console.log('VITE_PAJ_BUSINESS_API_KEY:', import.meta.env.VITE_PAJ_BUSINESS_API_KEY ? 'Present' : 'Missing');
  console.log('VITE_PAJ_API_URL:', import.meta.env.VITE_PAJ_API_URL || 'Not set');
  
  // Log all environment variables (only those prefixed with VITE_)
  const envVars = Object.entries(import.meta.env)
    .filter(([key]) => key.startsWith('VITE_'))
    .reduce((acc, [key, value]) => ({
      ...acc,
      [key]: key.includes('KEY') ? '***' + value.slice(-4) : value
    }), {});
  
  console.log('All Vite environment variables:', envVars);
};

export default debugEnv;
